<template>
	<div class="custom-table">
		<div class="custom-table-operate flex">
			<slot name="operate"></slot>
			<m-operate style="border-right-width: 1px;">
				<template #right>
					<c-button prepend-icon="tf-field-config" @click="globalDialog('fieldConfig', {props: {viewId: viewId}}, updateColumn)">字段配置</c-button>
				</template>
			</m-operate>
		</div>

		<c-table ref="list" :data="dataList" border :height="height" :paging="false" width-resize @widthResize="widthResizeHandle">
			<c-table-column v-if="drag"
				type="drag"
				width="32"
			></c-table-column>
			
			<c-table-column v-if="selector"
				type="selector"
				width="32"
			></c-table-column>
			
			<template v-for="(col, i) in columnList">
				<template v-if="col.is_display == 1">
					<c-table-column
						v-if="!col.is_custom && $scopedSlots[col.field_code]"
						:key="i"
						:label="col.field_title"
						:name="col.field_code"
						:width="col.width"
						:fixed="col.is_lock == 1 ? 'left' : false"
					>
						<template #default="{data}">
							<slot :name="col.field_code" :data="data"></slot>
						</template>
					</c-table-column>

					<c-table-column
						v-else-if="!col.is_custom"
						:key="i"
						:label="col.field_title"
						:name="col.field_code"
						:width="col.width"
						:fixed="col.is_lock == 1 ? 'left' : false"
					></c-table-column>

					<c-table-column
						v-else
						:key="i"
						:label="col.field_title"
						:name="col.field_code"
						:width="col.width"
						:fixed="col.is_lock == 1 ? 'left' : false"
						:required="col.config_json.attr.includes('required')"
					>
						<template #default="{data}">
							<c-input v-if="customConfig[col.field_code].type == 'text'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:disabled="customConfig[col.field_code].attr.includes('readonly')"
								:placeholder="customConfig[col.field_code].placeholder"
							></c-input>

							<c-input v-else-if="customConfig[col.field_code].type == 'number'"
								v-model="data.custom_fields_value_json[col.field_code]"
								type="number"
								:decimal="customConfig[col.field_code].attr.includes('decimal') ? customConfig[col.field_code].decimal : 0"
								:disabled="customConfig[col.field_code].attr.includes('readonly')"
								:placeholder="customConfig[col.field_code].placeholder"
							></c-input>

							<c-datetime v-else-if="customConfig[col.field_code].type == 'time'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:type="customConfig[col.field_code].format.split('|')[1]"
								:format="customConfig[col.field_code].format.split('|')[0]"
								:time-accuracy="customConfig[col.field_code].format.split('|')[2]"
								:disabled="customConfig[col.field_code].attr.includes('readonly')"
								:placeholder="customConfig[col.field_code].placeholder || '请选择'"
							></c-datetime>

							<c-select v-else-if="customConfig[col.field_code].type == 'option'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:options="customConfig[col.field_code].options"
								:multiple="customConfig[col.field_code].attr.includes('multiple')"
								:placeholder="customConfig[col.field_code].placeholder || '请选择'"
							></c-select>

							<c-upload-file v-else-if="customConfig[col.field_code].type == 'file'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:type="customConfig[col.field_code].suffix.join(',')"
								media
								:multiple="customConfig[col.field_code].attr.includes('multiple')"
								media-icon="tf-plus"
								:sort="false"
								:button="false"
							></c-upload-file>

							<c-upload-file v-else-if="customConfig[col.field_code].type == 'image'"
								v-model="data.custom_fields_value_json[col.field_code]"
								media
								:multiple="customConfig[col.field_code].attr.includes('multiple')"
								media-icon="tf-plus"
								:sort="false"
								:button="false"
							></c-upload-file>
						</template>
					</c-table-column>
				</template>
			</template>

			<template v-if="$scopedSlots.col_operate">
				<c-table-column
					type="button"
					label="操作"
					:width="operateWidth"
					:width-resize="false"
					:buttonLimit="operateLimit"
				>
					<template #default="{data, remove}">
						<slot name="col_operate" :data="data" :remove="remove"></slot>
					</template>
				</c-table-column>
			</template>
		</c-table>
	</div>
</template>

<script>
	export default {
		name: 'customTable',

		props: {
			viewId: [String, Number],
			drag: Boolean,
			selector: Boolean,
			height: {
				type: [String, Number],
				default: 'auto'
			},
			operateWidth: {
				type: [Number, String],
				default: 100
			},
			operateLimit: {
				type: [Number, String],
				default: 4
			}
		},

		data() {
			return {
				customConfig: {},
				columnList: [],
				dataList: []
			}
		},

		computed: {
			required() {
				let list = [];
				this.columnList.forEach(item => {
					if (item.is_custom == 1 && item.config_json.attr.includes('required')) {
						list.push(item.field_code);
					}
				});
				return list;
			}
		},

		mounted() {
			this._setTableData = this.$refs.list.setData;
			this.$refs.list.setData = data => {
				data.forEach(item => item.custom_fields_value_json = item.custom_fields_value_json || {});
				this._setTableData(data);
			}
			this._pushTableData = this.$refs.list.push;
			this.$refs.list.push = data => {
				data.custom_fields_value_json = data.custom_fields_value_json || {};
				this._pushTableData(data);
			}
		},

		methods: {
			init() {
				this._setTableData([]);
				this.updateColumn();
			},

			updateColumn() {
				this.request({
					url: '/sys_user_view/field_list',
					data: {
						view_id: this.viewId
					},
					success: data => {
						let config = {};
						data.field_list.forEach(item => {
							if (item.is_custom) {
								config[item.field_code] = item.config_json;
							}
						});
						this.customConfig = config;
						this.columnList = [];
						this.$nextTick(() => {
							this.columnList = data.field_list;
						});
					}
				});
			},

			validate() {
				let row = this.$refs.list.getData().find(row => {
					return this.required.find(item => {
						return row.custom_fields_value_json[item] === undefined;
					})
				})
				return row ? '请完善带星号的必填字段' : true;
			},

			widthResizeHandle(col) {
				let item = this.columnList.find(item => item.field_code == col.name);
				if (item) {
					item.width = col.width;
					this.request({
						url: '/sys_user_view/edit_field',
						data: {
							view_id: this.viewId,
							field_list: this.columnList.map(item => {
								return {
									field_id: item.field_id,
									width: item.width,
									is_display: item.is_display,
									is_lock: item.is_lock
								}
							})
						}
					})
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.custom-table {
		&-operate {
			>>> .m-operate {
				&[empty] + .m-operate,
				&:nth-child(1) {
					flex-grow: 1;
					width: 0;
					border-left-width: 1px;
				}

				&:nth-child(2) {
					padding-left: 8px;
				}

				&:nth-last-child(2) {
					padding-right: 0;
					border-right-width: 0;
				}
			}
		}

		>>> .c-upload-media-item,
		>>> .c-file-media {
			min-width: 32px;
			width: 32px;
			height: 32px;
			font-size: 20px;
		}

		>>> .c-upload-handle {
			display: none;
		}
	}
</style>
